import KM1 from "../../../../videos/king-materiaux/1.mp4";
import KM2 from "../../../../videos/king-materiaux/2.mp4";
import * as React from 'react';
export default {
  KM1,
  KM2,
  React
};